import React, { useLayoutEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import Editar from "../../../icons/editar.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModalEditar from "./editarDatosComunidad";
import { CircularProgress, Tabs, Tab, Box } from "@mui/material";
import TabPanel from "../../../components/tabs/Tabs";

import {
  getFinca,
  cambiarFinca,
} from "../../../services";
import { cambiarFormatoNombre, estadoServicio, ventaMasReciente, GRUPOS_SERVICIO } from "../../../functions/funciones";
import { CustomSwitch } from "../../../components/Buttons/Switch";
import { toast } from "react-toastify";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import ComunidadDocs from "../../../components/Comunidad/ComunidadDocs";
import { construirURLParamsFiltros } from "../../../functions/parametrosURL/funcionesParamsURL";
import Comentarios from "../../../components/Comunidad/comentarios";
import ComentariosAAFF from "../../../components/aaff/comentarios";
import { UsuarioContext } from "../../../providers/userContext";

// Perfiles internos que gestionan el QR de la comunidad
const PUEDE_VER_QR = ["ADMIN", "CONSUL", "VENT"];

const Comunidad = (props) => {
  const { t } = useTranslation('properties');
  const [finca, setFinca] = useState({});
  const [proveedores, setProveedores] = useState([]);
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [recargar, setRecargar] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const [savingSPA, setSavingSPA] = useState(false)
  const location = useLocation();
  let params = new URLSearchParams(location.search);
  const tabParam = parseInt(params.get("valorTab") ) ;
  const [value, setValue] = useState(tabParam || 1);
  const navigate = useNavigate();

  const user = useContext(UsuarioContext);
  useLayoutEffect(() => {
    
    getFinca(props.params.nifFinca).then((res) => {
      // res.documentos = { hojasVisita: { ano: 2023 } };
      // res.centrosTrabajo = [];
      // console.log(res)
      let provs = res.suppliers?.filter(objeto => objeto.status === true)
      const ultimaVenta = res.sales?.[res.sales.length - 1];
      const sale_cae = ventaMasReciente(res?.sales, GRUPOS_SERVICIO.cae);
      const sale_lopd = ventaMasReciente(res?.sales, GRUPOS_SERVICIO.lopd);
      const sale_cai = ventaMasReciente(res?.sales, GRUPOS_SERVICIO.cai);
      const instalacion_kae = res?.instalacionesKae?.find(i => i.prop_id === res.id) || null;
      res.estadoCae = sale_cae ? sale_cae?.estado_id === null ? 1 : sale_cae.estado_id : "-";
      res.estadoLopd = sale_lopd ? sale_lopd.estado_id === null ? 1 : sale_lopd.estado_id : "-";
      res.estadoCai = sale_cai ? sale_cai?.estado_id === null ? 1 : sale_cai.estado_id : "-";
      res.estadoKae = instalacion_kae ? instalacion_kae.estado_id === null ? 1 : instalacion_kae.estado_id : "-";
      setFinca(res);
      setProveedores(provs);
      if (user.rol === "ADMIN_CAI") {
        construirURLParamsFiltros(navigate, 1, 50, {}, 3);
        setValue(3);
      } else if (!res.gruposServicios.includes(1) && tabParam === 1 || !res.gruposServicios.includes(2) && tabParam === 2 || !tabParam) {
        const defaultTab = res.gruposServicios[0]

        construirURLParamsFiltros(navigate, 1, 50, {}, defaultTab);

        setValue(defaultTab)
      }
      setIsLoading(false);
    });
  }, [recargar]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return isLoading || finca == {} ? <CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} /> : 
    <>
      <ModalEditar
        finca={finca}
        opened={modalEditarOpened}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      {/* <div
        className="pageHeader"
        style={{
          backgroundImage: `url(${HeaderBackground})`,
          textAlign: "left",
        }}
      >
        Comunidad / <b>Vecinos {finca.razonSocial}</b>
      </div> */}
      <BreadCrumb rutas={[{path:'/aaff', label: t('aaff:title')}, {path:`/aaff/${finca?.aaff?.nif}/comunidades`, label:`${finca?.aaff?.razonSocial}`}, {path:`/aaff/${props.params.nif}/comunidades/${props.params.nifFinca}`, label:`${finca.razonSocial}`}]} style={{ margin: '0 10px'}} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('details.generalInfo')}</div>
          <div className="gridSubhead editarSubhead">
            <div>{t('details.communityData')}</div>
            {user.rol !== "ADMIN_CAI" && (
              <div
                className="editarBtn"
                onClick={() => setModalEditarOpened(true)}
              >
                <span style={{ marginRight: 10 }}>{t('common:actions.edit')}</span>{" "}
                <img src={Editar} alt={t('common:actions.edit')} />
              </div>
            )}
          </div>
          <div className="datosGrid">
            <p>
              <b>{t('details.communityName')}:</b> {finca.razonSocial}
            </p>
            <p>
              <b>{t('details.address')}:</b> {finca.direccion}
            </p>
            <p>
              <b>{t('details.nif')}:</b> {finca.nif}
            </p>
            <p>
              <b>{t('details.municipality')}:</b> {cambiarFormatoNombre(finca.municipio)}
            </p>
            <p>
              <b>{t('details.province')}:</b> {finca.provincia}
            </p>
            <p>
              <b>{t('details.postalCode')}:</b> {finca.codigoPostal}
            </p>
            <p>
              <b>{t('details.contactPerson')}:</b> {finca.nombreContacto}
            </p>
            <p>
              <b>{t('details.contactPhone')}:</b> {finca.telefonoContacto}
            </p>
            <p>
              <b>{t('details.contactEmail')}:</b> {finca.emailContacto}
            </p>
            {user.rol !== "ADMIN_CAI" && (
              <>
                <p>
                  <b>{t('details.presidentName')}:</b> {finca.nombrePresidente}
                </p>
                <p>
                  <b>{t('details.presidentNif')}:</b> {finca.nifPresidente}
                </p>
              </>
            )}
            {user.rol !== "ADMIN_CAI" && (
              <p>
                <b>{t('details.caeStatus')}: </b>
                <span style={{ color: finca.estadoCae === 1 || finca.estadoCae == null ? "#3eae3e"  : finca.estadoCae === 2 || finca.estadoCae === 3 ? '#FF8300' : finca.estadoCae === 4 || finca.estadoCae === 5 ? "#EE4534" : "#000"}}>
                  {finca.estadoCae === "-" ? finca.estadoCae : estadoServicio(finca.estadoCae, t)}
                </span>
              </p>
            )}
            {user.rol !== "ADMIN_CAI" && (
              <p>
                <b>{t('details.lopdStatus')}: </b>
                <span  style={{ color: finca.estadoLopd === 1 || finca.estadoLopd == null ? "#3eae3e"  : finca.estadoLopd === 2 || finca.estadoLopd === 3 ? '#FF8300' : finca.estadoLopd === 4 || finca.estadoLopd === 5 ? "#EE4534" : "#000"}}>
                  {finca.estadoLopd === "-" ? finca.estadoLopd : estadoServicio(finca.estadoLopd, t)}
                </span>
              </p>
            )}
            {PUEDE_VER_QR.includes(user.rol) && (
              <p>
                <b>{t('details.qrAccess')}: </b>
                <span style={{ color: finca.qrOmniaHogar ? "#0097a7" : "#3eae3e" }}>
                  {finca.qrOmniaHogar ? t('details.qrAccessOmnia') : t('details.qrAccessCae')}
                </span>
              </p>
            )}
            <p>
              <b>{t('details.caiStatus')}: </b>
              <span  style={{ color: finca.estadoCai === 1 || finca.estadoCai == null ? "#3eae3e"  : finca.estadoCai === 2 || finca.estadoCai === 3 ? '#FF8300' : finca.estadoCai === 4 || finca.estadoCai === 5 ? "#EE4534" : "#000"}}>
                {finca.estadoCai === "-" ? finca.estadoCai : estadoServicio(finca.estadoCai, t)}
              </span>
            </p>
            {user.rol !== "ADMIN_CAI" && (
              <p>
                <b>{t('details.kaeStatus')}: </b>
                <span  style={{ color: finca.estadoKae === 1 || finca.estadoKae == null ? "#3eae3e"  : finca.estadoKae === 2 || finca.estadoKae === 3 ? '#FF8300' : finca.estadoKae === 4 || finca.estadoKae === 5 ? "#EE4534" : "#000"}}>
                  {finca.estadoKae === "-" ? finca.estadoKae : estadoServicio(finca.estadoKae, t)}
                </span>
              </p>
            )}
            {/* <p style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <b>{t('details.hideSPA')}:</b>
              <CustomSwitch
                name="ocultarSPA"
                checked={finca.ocultarSPA || false}
                disabled={savingSPA}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSavingSPA(true);
                  cambiarFinca(finca.nif, { ocultarSPA: checked })
                    .then((res) => {
                      if (res.status === 201) {
                        setFinca({ ...finca, ocultarSPA: checked });
                      } else {
                        toast.error(t('details.hideSPAError'));
                      }
                    })
                    .catch(() => {
                      toast.error(t('details.hideSPAError'));
                    })
                    .finally(() => {
                      setSavingSPA(false);
                    });
                }}
              />
            </p> */}
            {/* <p>
            <b>Activo:</b> {finca.activo==true || finca.activo==undefined ? <span style={{ color: 'green' }}>Si</span> :  <span style={{ color: 'red' }}>No</span>}
            </p> */}

            {/* <p><b>Fecha de alta:</b> {new Date(finca.fechaAlta.seconds * 1000).toLocaleDateString()}</p> */}
          </div>
            {user.rol !== "ADMIN_CAI" && (
              <>
                <div className="datosGrid">
                  <ComentariosAAFF aaff={finca.aaff} />
                </div>
                <hr />
                <div className="datosGrid">
                  <Comentarios finca={finca} />
                </div>
              </>
            )}
          <div className="gridSubhead">{t('details.communityDocuments')}</div>
          <Box sx={{ padding: "10px 40px", border: "none" }}>
            {!finca?.gruposServicios || finca?.gruposServicios.length === 0 ? (
              t('details.noDocuments')
            ) : (
              <Tabs value={value} onChange={handleChange} aria-label="tabs example">
                {user.rol !== "ADMIN_CAI" && finca?.gruposServicios?.includes(1) && <Tab style={{ color: "#92004D" }} label="CAE" value={1} />}
                {user.rol !== "ADMIN_CAI" && finca?.gruposServicios?.includes(2) && <Tab style={{ color: "#92004D" }} label="LOPD" value={2} />}
                {finca?.gruposServicios?.includes(3) && <Tab style={{ color: "#92004D" }} label="CAI" value={3} />}
              </Tabs>
            )}
          </Box>
          {finca?.gruposServicios?.filter((g) => user.rol !== "ADMIN_CAI" || g === 3).map((grupoServicio) => (
                
                <TabPanel key={grupoServicio} value={value} index={grupoServicio}>
                  <div className="pageGrid" style={{ gap:0 }}>
                    {grupoServicio === 1 && (
                      <>
                        <div id="ventas" >
                          <ComunidadDocs idPropiedad={finca.id} aaff={finca.aaff} grupoServicio={1} />
                        </div>
                        <div id="proveedores" className="tableContainer">
                          <div className="gridHeadProv">{t('details.suppliers')}</div>
                          <div >
                            <table>
                            <tbody>
                            {proveedores.length === 0 ? (
                              <small style={{ paddingLeft: "14px" }}>{t('details.noSuppliers')}</small>
                            ) : (
                              proveedores.map((e, i) => {
                                return (
                                  <tr key={i}>
                                    <td style={{ width: "100%", padding: 10 }}>
                                      <Link to={"/proveedores/" + e.nif}>
                                        {e.razonSocial}
                                        <p style={{ opacity: 0.55, fontSize: 14 }}>{e?.serviceSupps?.length > 0 ? e?.serviceSupps?.find((serv) => serv.id === e.service_to_propertie?.service)?.nombre : null}</p>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                            </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                    {grupoServicio === 2 && <ComunidadDocs idPropiedad={finca.id} grupoServicio={2}/>}
                    {grupoServicio === 3 && <ComunidadDocs idPropiedad={finca.id} grupoServicio={3}/>}
                  </div>
                </TabPanel>
            ))}
        </div>
        {/* <div className="gridCard">
          <div className="gridHead">PROVEEDORES</div>
          <table style={{ margin: 15 }}>
            <thead>
              <tr
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                <th></th>
                // <th>Aviso</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(proveedores)
                ? proveedores.map((e, i) => {
                    return (
                      <tr key={i}>
                        <td
                          style={{
                            width: "100%",
                            paddingBottom: 10,
                            paddingTop: 10,
                          }}
                        >
                          <Link to={"/proveedores/" + e.nif}>
                            {e.razonSocial}
                            <p style={{ opacity: 0.55, fontSize: 14 }}>
                              {
                                e?.serviceSupps?.length > 0 ? e?.serviceSupps?.find( serv => serv.id === e.service_to_propertie.service)?.nombre : null
                              }
                              // {e.serviceSupps.map((s, j) => {
                              //   return e.serviceSupps.length === j + 1
                              //     ? s.nombre
                              //     : s.nombre + ", ";
                              // })} 
                            </p>
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                : null}
              //  {proveedores?.map((e, i) => {
              //               return (
              //               <tr key={i}>
              //                   <td style={{ width: '100%', paddingBottom: 10, paddingTop: 10 }}>
              //                       <Link to={"/proveedores/" + e.nif}>{e.razonSocial}<p style={{ opacity: 0.55, fontSize: 14 }}>{serviciosProveedores[e.servicio]}</p></Link>
              //                   </td>
              //               </tr>
              //               )
              //           })} 
            </tbody>
          </table>
        </div> */}
      </div>
      <style jsx="true">{`
        .css-1aquho2-MuiTabs-indicator {
          background-color: #92004D;
        }
        .gridHeadProv {
          border-radius: 5px 5px 0 0;
          background-color: #92004D;
          color: #ffffff;
          padding: 10px 15px;
          font-weight: bold;
          font-size: 12px;
          height: 34px;
        }
        #ventas{
          width:70%;
        }
        #proveedores{
          width:30%;
        }
        .pageGrid{
          display:flex;
          flex-direction: row;
        }
        @media screen and (max-width: 992px) {
          #ventas{
            overflow-y: auto;
            width:100%;
          }
          #proveedores{
            width:100%;
          }
          .pageGrid{
            flex-direction: column;
          }
        }
      `}</style>
    </>
};

export default withRouter(Comunidad);


